<template>
  <div class="d-flex">
    <div class="d-flex mx-auto px-1 py-1">
      <div v-for="(tab, index) in tabs" :key="'tab' + index">
        <div
          :class="index === activeClass ? 'active-tab' : ''"
          class="px-3 py-2 mx-2 normal-tab"
          @click="changeTab(index)"
        >
          <span>{{ tab.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { tabViewDuoCare } from '../../constant';

export default {
  data() {
    return {
      tabs: tabViewDuoCare,
    };
  },
  computed: {
    ...mapState('duo_care', ['activeClass']),
  },
  methods: {
    ...mapActions('duo_care', ['setActiveTab']),
    changeTab(index) {
      this.setActiveTab(index);
    },
  },
};
</script>

<style lang="scss" scoped>
.normal-tab {
  color: #B2AEA6;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 7px;
  background: #E0E0E0;
  cursor: pointer;
}
.active-tab {
  border-radius: 7px;
  background: #0EA5BA;
  color: #fff;
}
</style>
